import React from 'react';
import { Outlet } from 'react-router-dom';

export default function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-theme-bg-tertiary">
      {/* <header className="sticky top-0 z-10 flex h-14 items-center justify-center border-b border-gray-200 bg-surface">
        <img
          src="/svg/altCaseNavLogo.svg"
          alt="Altcase"
          className="h-7 w-auto"
        />
      </header> */}

      <main className="flex flex-1 w-full items-center justify-center">
        <Outlet />
      </main>
{/* 
      <footer className="sticky bottom-0 flex h-14 items-center justify-center border-t border-gray-200 bg-surface text-sm text-gray-500">
        © {new Date().getFullYear()} Altcase. All rights reserved.
      </footer> */}
    </div>
  );
}
